export const MINIMUM_DEPOSIT = 100;
export const MINIMUM_WITHDRAW = 100;
export const DEPOSIT_MQR_TIMER_SEC = 300;
export const DEPOSIT_MQR_DEMO_BTN = {};
export const WithdrawPreviousBank = true;
export const DepositBonusOffers = false;
export const WithdrawInfoPopup = false;
export const NonXoroPeDepositSupportNumber = {link: "" , displaynumber: ""};
export const DepositBonusOffersDefault = false;
export const DepositBonusOffersInfoPopup = false;
export const DEPOSIT_XOROPE_TIMER = 120;
export const DepositXoropeOptionsFileUpload = false;
export const DepositOptionsWarningInfoPopup = true;